import { type NavItem } from './navigation-types';
import { operationsNavItems } from './nav-operations';
import { procurementNavItems } from './nav-procurement';
import { financeNavItems } from './nav-finance';

export type { NavItem } from './navigation-types';

export const internalNavigation: NavItem[] = [
  ...operationsNavItems,
  ...procurementNavItems,
  ...financeNavItems,
];
